module.exports = __webpack_public_path__ + "static/media/baño_principal.23124f19.jpg";